var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#192235"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_1483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C14.473 10 10 14.4725 10 20C10 25.5269 14.4725 30 20 30C25.527 30 30 25.5275 30 20C30 14.473 25.5275 10 20 10ZM20 28.6046C15.2554 28.6046 11.3954 24.7446 11.3954 20C11.3954 15.2554 15.2554 11.3954 20 11.3954C24.7446 11.3954 28.6046 15.2554 28.6046 20C28.6046 24.7446 24.7446 28.6046 20 28.6046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7033 22.6533C19.1504 22.6533 18.7029 23.114 18.7029 23.6668C18.7029 24.2065 19.1373 24.6804 19.7033 24.6804C20.2693 24.6804 20.7168 24.2065 20.7168 23.6668C20.7168 23.114 20.2561 22.6533 19.7033 22.6533ZM19.8744 14.9792C18.0973 14.9792 17.2812 16.0323 17.2812 16.7431C17.2812 17.2565 17.7156 17.4934 18.071 17.4934C18.7818 17.4934 18.4923 16.4798 19.8349 16.4798C20.493 16.4798 21.0196 16.7694 21.0196 17.375C21.0196 18.0857 20.2824 18.4938 19.848 18.8623C19.4663 19.1914 18.9661 19.7311 18.9661 20.8631C18.9661 21.5476 19.1504 21.745 19.6901 21.745C20.335 21.745 20.4667 21.4555 20.4667 21.2053C20.4667 20.5208 20.4798 20.126 21.2038 19.56C21.5592 19.2835 22.678 18.3884 22.678 17.1511C22.678 15.9138 21.5592 14.9792 19.8744 14.9792Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_1483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.f52413e9624b20bec156bd1a4efc66b8.svg";
export { ForwardRef as ReactComponent };